<template>
  <div class="audio-record">
    <AudioPlay class="audio-play" v-if="isAudioBack" :audio-url="audioUrl" />
    <div v-show="isRecording" class="record-wrap">
      <div class="animate-wrap">
        <canvas ref="playCanvas" />
      </div>
      <div class="record-bottom" />
      <div class="record-time">
        <div class="duration-time">
          录音：{{ recordTimeDesc }}
        </div>
        <div class="last-time" v-if="lastTime > 0">
          剩余：{{ lastTime }}s
        </div>
      </div>
    </div>
    <div class="btn-wrap">
      <a-button
        class="audio-btn"
        type="link"
        :disabled="recordDisabled"
        @click="handleRecord"
      >
        <span class="btn-txt" :class="{'recording-icon': isRecording }">
          <i />
          {{ isRecording ? '停止录音' : '开始录音' }}
        </span>
      </a-button>
      <a-button class="audio-clear" type="link" v-if="isAudioBack" @click="resetRecord">
        清除
      </a-button>
    </div>
  </div>
</template>
<script>
import AudioPlay from '@/components/Audio/AudioPlay.vue'
import Recorder from 'js-audio-recorder'
import lamejs from 'lamejs'
import { getUserId } from '@/utils/tools'
import { message } from 'ant-design-vue'

// 未开始
const NO_RECORD = 0
// 进行中
const RECORDING = 1
// 已结束
const RECORDED = 2
export default {
  components: {
    AudioPlay
  },
  props: {
    // 录音最长时长，默认3分钟
    maxVideoTime: {
      type: Number,
      default: 3 * 60
    }
  },
  data() {
    return {
      // 录音状态：0: 未开始 1:进行中 2:已结束
      recordStatus: NO_RECORD,
      // 录音完成后播放的 url
      audioUrl: '',
      // 录音时间，单位秒，整数
      recordTimeInt: 0,
      // 录音的实例
      recorder: null,
      // 录音按钮置灰
      recordDisabled: false,
      userId: getUserId()
    }
  },
  computed: {
    // 录音未开始
    isNoRecord() {
      const { recordStatus } = this
      return recordStatus === NO_RECORD
    },
    // 录音中
    isRecording() {
      const { recordStatus } = this
      return recordStatus === RECORDING
    },
    // 录音回放
    isAudioBack() {
      const { recordStatus } = this
      return recordStatus === RECORDED && this.recordTime
    },
    recordTimeDesc() {
      const { recordTimeInt } = this
      // console.log(recordTimeInt)
      const minutes = Math.floor(recordTimeInt / 60)
      const seconds = Math.ceil(recordTimeInt % 60)
      return `${this.fixZero(minutes)}:${this.fixZero(seconds)}`
    },
    lastTime() {
      const { recordTimeInt, maxVideoTime } = this
      const lastTime = maxVideoTime - recordTimeInt
      // 最后 10s 显示倒计时
      if (lastTime <= 10) {
        return lastTime
      }
      return 0
    }
  },
  created() {
    // 录音的时长
    this.recordTime = 0
    this.drawPlayRecordId = null
    const recorder = new Recorder()
    this.recorder = recorder
    recorder.onprogress = this.onprogress
  },
  mounted() {
    const pCanvas = this.$refs.playCanvas
    pCanvas.width = 212
    pCanvas.height = 18
    const pCtx = pCanvas.getContext('2d')
    this.pCanvas = pCanvas
    this.pCtx = pCtx
    this.initCanvas()
  },
  beforeDestroy() {
    const { recorder, drawPlayRecordId } = this
    drawPlayRecordId && cancelAnimationFrame(drawPlayRecordId)
    // 销毁录音实例
    recorder.destroy()
  },
  methods: {
    fixZero(num) {
      return num < 10 ? `0${num}` : num
    },
    onprogress(params) {
      const { duration } = params
      const { maxVideoTime } = this
      this.recordTime = duration
      const recordTimeInt = Math.floor(this.recordTime)
      // TODO 最后一秒不显示，转换成 mp3 后才显示
      if (recordTimeInt !== this.recordTimeInt) {
        this.recordTimeInt = recordTimeInt
      }
      if (recordTimeInt >= maxVideoTime) {
        // 超时了，自动停止录音
        this.stopRecord()
      }
      // console.log('录音时长(秒)', duration)
      // console.log('录音大小(字节)', params.fileSize)
      // console.log('录音音量百分比(%)', params.vol)
    },
    /**
     * 操作开始录音、停止录音按钮
     */
    handleRecord() {
      const { isRecording, recordDisabled } = this
      if (recordDisabled) {
        return
      }
      if (isRecording) {
        // 录音中，停止录音
        this.stopRecord()
      } else {
        // 开始录音
        this.startRecord()
        this.$emit('startRecord')
      }
    },
    /**
     * 开始录音
     */
    startRecord() {
      // 重置
      this.resetRecord()
      if (this.isDenied) {
        this.recordDeniedTip()
        return
      }
      this.recordStatus = RECORDING
      this.recorder.start().then(() => {
        // 开始录音
        console.log('开始录音')
        this.drawPlayRecord()
      }, error => {
        // 出错了
        // TODO 收集报错信息
        console.log(error)
        if (error.message.indexOf('Permission denied') !== -1) {
          this.isDenied = true
          this.recordDeniedTip()
        } else {
          this.recordDeniedTip(`录音失败：${error}`)
        }
        this.resetRecord()
      })
    },
    /**
     * 禁止了麦克风权限的提示
     */
    recordDeniedTip(msg) {
      message.error(msg || '请开启麦克风权限后再录音')
    },
    /**
     * 重置录音
     */
    resetRecord() {
      // 如果在录音中，停止录音
      if (this.isRecording) {
        this.stopRecord()
      }
      this.audioUrl = ''
      this.recordStatus = NO_RECORD
      this.recordTime = 0
      this.recordTimeInt = 0
      this.initCanvas()
    },
    /**
     * 停止录音
     */
    stopRecord() {
      this.recordDisabled = true
      this.recorder.stop()
      const { drawPlayRecordId } = this
      if (drawPlayRecordId) {
        cancelAnimationFrame(drawPlayRecordId)
      }
      try {
        const wav = this.recorder.getWAV()
        const blob = new Blob([wav], { type: 'audio/wav' })
        this.audioUrl = URL.createObjectURL(blob)
      } catch (error) {
        console.log('停止录音出错', error)
      } finally {
        this.recordDisabled = false
        this.recordStatus = RECORDED
      }
    },
    // https://github.com/2fps/recorder/issues/33 支持mp3
    // 请用 16位的采样位数
    convertToMp3(wavDataView) {
      const { recorder } = this
      // 获取wav头信息
      const wav = lamejs.WavHeader.readHeader(wavDataView) // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
      const { channels, sampleRate } = wav
      console.log('wav', wav)
      const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128)
      // 获取左右通道数据
      const result = recorder.getChannelData()
      const buffer = []

      const leftData = result.left && new Int16Array(result.left.buffer, 0, result.left.byteLength / 2)
      const rightData = result.right && new Int16Array(result.right.buffer, 0, result.right.byteLength / 2)
      const remaining = leftData.length + (rightData ? rightData.length : 0)

      const maxSamples = 1152
      for (let i = 0; i < remaining; i += maxSamples) {
        const left = leftData.subarray(i, i + maxSamples)
        let right = null
        let mp3buf = null

        if (channels === 2) {
          right = rightData.subarray(i, i + maxSamples)
          mp3buf = mp3enc.encodeBuffer(left, right)
        } else {
          mp3buf = mp3enc.encodeBuffer(left)
        }

        if (mp3buf.length > 0) {
          buffer.push(mp3buf)
        }
      }

      const enc = mp3enc.flush()

      if (enc.length > 0) {
        buffer.push(enc)
      }
      console.log('mp3 转换完成')
      return new Blob(buffer, { type: 'audio/mp3' })
    },
    drawLine(pCtx, start, end) {
      // 画笔起始位置
      pCtx.moveTo(start.x, start.y)
      // 画笔移动的目的地
      pCtx.lineTo(end.x, end.y)
      pCtx.lineWidth = 2
      pCtx.strokeStyle = '#C1C6D0'
      pCtx.lineCap = 'round'
    },
    initCanvas() {
      this.drawAudioLines(() => 3)
    },
    /**
     * dealY: 处理线的高度
     */
    drawAudioLines(dealY) {
      const { pCanvas, pCtx } = this

      // 填充背景色
      pCtx.fillStyle = 'rgb(255, 255, 255)'
      pCtx.fillRect(0, 0, pCanvas.width, pCanvas.height)

      pCtx.beginPath()

      // 36 个竖线
      const totalLine = 36
      var sliceWidth = pCanvas.width * 1.0 / totalLine
      var x = 2 // 绘制点的x轴位置
      const startY = pCanvas.height / 2
      for (var i = 0; i < totalLine; i++) {
        const y = dealY(i, totalLine)
        this.drawLine(pCtx, {
          x,
          y: startY - y / 2
        }, {
          x,
          y: startY + y / 2
        })
        // 依次平移，绘制所有点
        x += sliceWidth
      }

      // pCtx.lineTo(pCanvas.width, pCanvas.height / 2);
      pCtx.stroke()
    },
    /**
     * 画声音的波浪线
     */
    drawPlayRecord() {
      const { recorder } = this
      // 用requestAnimationFrame稳定60fps绘制
      setTimeout(() => {
        this.drawPlayRecordId = requestAnimationFrame(() => this.drawPlayRecord())
      }, 250)
      // 实时获取音频大小数据
      const dataArray = recorder.getRecordAnalyseData()
      const bufferLength = dataArray.length

      this.drawAudioLines((i, totalLine) => {
        var v = dataArray[Math.floor(bufferLength * (i / totalLine))] / 128.0
        var y
        const rate = Math.floor(v * 100)
        // console.log(rate)
        if (rate <= 85) {
          y = 3
          // } else if ( rate >= 90 && rate < 96 ) {
          //   y = 4
          // } else if ( rate >= 96 && rate <= 100) {
          //   y = 6
        } else if (rate > 115) {
          y = 18
        } else {
          y = 3 + ((rate - 90) / 30) * 15
          // console.log(((rate - 90)/20), y)
          y = y > 18 ? 18 : y
          if (rate === 100) {
            y = 6
          }
        }
        return y
      })
    },
    upload(signature, audioName) {
      return new Promise((resolve, reject) => {
        this.recordDisabled = true
        // 转换成 mp3 时页面不会更新状态了，需要 setTimeout 加个延时先让页面状态更新
        setTimeout(() => {
          this.uploadRecord(signature, audioName).then(resolve).catch(reject).finally(() => {
            this.recordDisabled = false
          })
        }, 50)
      })
    },
    async uploadRecord(signature, audioName) {
      const { recorder } = this
      const mp3Blob = this.convertToMp3(recorder.getWAV())
      const file = new File([mp3Blob], audioName, { type: 'audio/mp3' })
      console.log('signature', signature)
      const res = await this.$axxUpload.uploadFilesToAxx(file, (progressEvent, sign) => {
        // 进度
        // console.log(sign, progressEvent)
      }, signature)
      return {
        ...res.results[0].body,
        audioDuration: Number(this.recordTime.toFixed(2))
      }
    }
  }
}
</script>
<style lang="less" scoped>
.audio-record {
  width: 100%;
}
.record-wrap {
  width: 100%
}
.play-wrap {
  position: relative;
}
.audio-play {
  width: 100%;
  height: 44px;
}
.animate-wrap {
  width: 212px;
  margin: 0 auto 8px auto;
}
// .record-animate {
//   height: 18px;
//   width: 100%;
// }
.record-bottom {
  width: 252px;
  height: 4px;
  background: #F0F2F4;
  margin: 0 auto;
}
.record-time {
  margin: 6px 0 14px 0;
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
  font-weight: 400;
  font-size: 12px;
  color: #505873;
  line-height: 20px;
  .last-time {
    color: #FF5C5C;
  }
}
.btn-wrap {
  width: 100%;
  margin-bottom: 25px;
  margin-top: 14px;
  position: relative;
  .audio-clear {
    position: absolute;
    right: -12px;
    bottom: 0;
    height: auto;
  }
}
.audio-btn {
  background: transparent !important;
  border-color: transparent !important;
  padding: 0 !important;
  height: auto !important;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  .btn-txt {
    display: inline-flex;
    align-items: center;
    i {
      display: inline-block;
      width: 14px;
      height: 14px;
      background: url('~@/static/images/audio/play.svg') center no-repeat;
      background-size: auto 14px;
      margin-right: 4px;
    }
    &.recording-icon {
      i {
        background-image: url('~@/static/images/audio/stop.svg')
      }
    }
  }
}
</style>